import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const NAMES = ['María', 'Laura', 'Carolina', 'Luciana', 'Valentina', 'Sofía', 'Camila', 'Florencia', 'Andrea', 'Daniela', 'Romina', 'Julieta', 'Agustina', 'Micaela', 'Paula', 'Martina', 'Celeste', 'Natalia'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'Paraná', 'San Juan', 'Quilmes', 'Lanús', 'Morón'];
const TIMES = ['hace 2 min', 'hace 5 min', 'hace 8 min', 'hace 12 min', 'hace 15 min', 'hace 20 min', 'hace 1 hora'];
const getRandomItem = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];
const getRandomInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchase, setPurchase] = useState({
    name: 'María',
    city: 'Buenos Aires',
    time: 'hace 5 min'
  });
  useEffect(() => {
    let showTimeout: NodeJS.Timeout;
    let hideTimeout: NodeJS.Timeout;
    const scheduleNext = (delay: number) => {
      showTimeout = setTimeout(() => {
        // Generate new random purchase data
        setPurchase({
          name: getRandomItem(NAMES),
          city: getRandomItem(CITIES),
          time: getRandomItem(TIMES)
        });
        // Show popup
        setIsVisible(true);
        // Schedule hiding the popup after 5 seconds
        hideTimeout = setTimeout(() => {
          setIsVisible(false);
          // Schedule the next popup between 7 and 12 seconds
          scheduleNext(getRandomInt(7000, 12000));
        }, 5000);
      }, delay);
    };
    // Start the first popup after 5 seconds
    scheduleNext(5000);
    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, []);
  return <AnimatePresence data-id="element-145">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 w-[320px] max-w-[calc(100vw-2rem)] bg-white rounded-2xl p-4 shadow-xl border border-green-100 flex items-start gap-3" data-id="element-146">
          <div className="w-10 h-10 rounded-full bg-brand-accent text-white flex items-center justify-center font-bold text-lg flex-shrink-0 shadow-sm" data-id="element-147">
            {purchase.name.charAt(0)}
          </div>

          <div className="flex-1 min-w-0" data-id="element-148">
            <p className="text-sm text-brand-textMuted truncate" data-id="element-149">
              <span className="font-semibold text-brand-textBody" data-id="element-150">
                {purchase.name}
              </span>{' '}
              de {purchase.city}
            </p>
            <p className="text-sm font-medium text-brand-text mt-0.5" data-id="element-151">
              Compró Salud en tu Plato{' '}
              <span className="inline-block ml-0.5" data-id="element-152">✅</span>
            </p>
            <p className="text-xs text-brand-textMuted mt-1" data-id="element-153">{purchase.time}</p>
          </div>

          <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 transition-colors p-1 -mt-1 -mr-1 rounded-full hover:bg-gray-50 flex-shrink-0" aria-label="Cerrar notificación" data-id="element-154">
            <XIcon className="w-4 h-4" data-id="element-155" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}